module.exports = __webpack_public_path__ + "img/1518441949.d908403b.jpg";